<template>
    <div
        class="app-container"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-card>
            <el-form
                :model="voucherQueryModel"
                label-width="120px"
                label-position="left"
            >
                <div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="记录日期" label-width="80px">
                                <el-date-picker
                                    v-model="time"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    size="mini"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-button
                                type
                                size="mini"
                                icon="el-icon-search"
                                class="pull-right"
                                @click="search"
                                >查询</el-button
                            >
                            <el-radio-group
                                v-model="isAll"
                                size="mini"
                                class="pull-right right-20"
                            >
                                <el-radio-button label="false"
                                    >显示失败项</el-radio-button
                                >
                                <el-radio-button label="true"
                                    >显示成功项</el-radio-button
                                >
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </div>
            </el-form>

            <el-table
                :data="tableData"
                size="mini"
                style="width: 100%; overflow: auto"
                border
            >
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                    prop="tenantName"
                    label="租户"
                    min-width="80px"
                ></el-table-column>
                <el-table-column
                    prop="purchasedName"
                    label="已购模块"
                    min-width="180px"
                ></el-table-column>
                <el-table-column label="记录日期" min-width="150px">
                    <template slot-scope="scope">{{
                        timeFormat(scope.row)
                    }}</template></el-table-column
                >
                <el-table-column
                    prop="executeStatus"
                    label="执行情况"
                    min-width="150px"
                ></el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="DataApi"
                :GetData="getTableData"
                :queryParam="queryParam"
                :isInit="false"
                :errorFunc="errorHandler"
            ></pagerBar>
        </el-card>
    </div>
</template>
  
  <script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    name: 'hangfireVoucher',
    data() {
        return {
            isPos: false,

            openloading: false,
            isVoucherCreate: false,
            queryParam: {},
            CurrnetMID: 0,
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherRecordView',
            DataApi:
                config.BASE_Middle_API +
                'VoucherRecordView/GetVoucherRecordInfoList', //获取源数据接口 需提供
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            storesList: [],
            stores: [],
            tableData: [],
            accountList: [],
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            businesstime: [],
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
                storeID: ''
            },
            brandID: '',
            isAll: false,
            selOrder: [],
            selOrderIds: []
        }
    },
    components: { pagerBar },
    methods: {
        timeFormat(row) {
            return moment(row.recordTime).format('YYYY-MM-DD')
        },
        handleSelectionChange(val) {
            const _this = this
            if (_this.selOrder.length == 0) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            } else {
                let b = false
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        b = true
                        item.value = val
                    }
                })
                if (!b) {
                    _this.selOrder.push({
                        key: _this.$refs.refPagerBar.currentPage,
                        value: val
                    })
                }
            }
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.tableData.find(
                            (tableRow) => tableRow.id === row.id
                        )
                        this.$refs.tableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.tableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item.id === row.id)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (!_this.selOrder.find((item) => item.id === key.id)) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item.billNO !== row.billNO
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.tableData)
            } else {
                this.removeRows(this.tableData)
            }
        },
        errorHandler() {
            this.openloading = false
        },
        search() {
            this.openloading = true
            this.voucherQueryModel.isAll = this.isAll
            if (this.time != null && this.time != [] && this.time.length == 2) {
                this.voucherQueryModel.startTime = moment(this.time[0]).format(
                    'YYYY-MM-DD'
                )
                this.voucherQueryModel.endTime = moment(this.time[1]).format(
                    'YYYY-MM-DD'
                )
            }
            let confirmData = Object.assign({}, this.voucherQueryModel)
            this.queryParam = Object.assign({}, confirmData)
        },

        getTableData(d) {
            this.tableData = d
            this.openloading = false
        }
    }
}
</script>
  
  <style scoped>
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    height: calc(100vh - 154px) !important;
    overflow-y: auto;
}
</style>
  